export default __webpack_public_path__ + "static/media/monkeyActive.6fd5381c.png";